import { AnimatePresence, motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { cn } from "../lib/cn";
import { useTheme } from "../hooks/useTheme";

/** Sun/moon cross-fade with a small rotation. Announces the target state. */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const nextLabel = theme === "dark" ? "Switch to light theme" : "Switch to dark theme";

  return (
    <button
      type="button"
      onClick={toggle}
      title={nextLabel}
      aria-label={nextLabel}
      className={cn(
        "relative grid size-10 place-items-center overflow-hidden rounded-lg border border-transparent",
        "text-content-muted transition-colors hover:bg-surface-sunken hover:text-content",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-500",
        className,
      )}
    >
      <AnimatePresence initial={false} mode="wait">
        <motion.span
          key={theme}
          initial={{ opacity: 0, rotate: -75, scale: 0.6 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: 75, scale: 0.6 }}
          transition={{ duration: 0.24, ease: [0.16, 1, 0.3, 1] }}
          className="absolute grid place-items-center"
        >
          {theme === "dark" ? (
            <Moon size={17} className="text-gold-400" aria-hidden="true" />
          ) : (
            <Sun size={17} className="text-gold-600" aria-hidden="true" />
          )}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
